import { render } from "./ReportSaver.vue?vue&type=template&id=0c30b6aa&scoped=true"
import script from "./ReportSaver.vue?vue&type=script&lang=js"
export * from "./ReportSaver.vue?vue&type=script&lang=js"

import "./ReportSaver.vue?vue&type=style&index=0&id=0c30b6aa&lang=css"
import "./ReportSaver.vue?vue&type=style&index=1&id=0c30b6aa&lang=scss&scoped=true"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c30b6aa"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
